<template>
  <BlocksBlockRichText
    v-if="generalInternalStore.footer.certificatesEntities"
    :data="generalInternalStore.footer.certificatesEntities"
  />
</template>

<script setup lang="ts">
import { useGeneralInternalStore } from "~/stores/generalInternal";

const generalInternalStore = useGeneralInternalStore();
</script>
